export const loadedCovers = new Set<string>();
export const failedCovers = new Set<string>();
const pending = new Map<string, Promise<void>>();

/** Prepare the first visible row before publishing new feed data to the screen. */
export function prepareCover(src: string): Promise<void> {
  if (loadedCovers.has(src) || failedCovers.has(src)) return Promise.resolve();
  const existing = pending.get(src);
  if (existing) return existing;
  const image = new Image();
  image.src = src;
  const request = image.decode().then(() => { loadedCovers.add(src); }, () => { failedCovers.add(src); });
  pending.set(src, request);
  void request.finally(() => pending.delete(src));
  return request;
}

export async function prepareFeedCovers(urls: string[]) {
  let timeout = 0;
  await Promise.race([
    Promise.all(urls.map(prepareCover)),
    new Promise<void>(resolve => { timeout = window.setTimeout(resolve, 3000); }),
  ]);
  window.clearTimeout(timeout);
}
